module.exports = __webpack_public_path__ + "static/media/thumbnail.9890f16b.jpg";